module.exports = __webpack_public_path__ + "static/media/cromo.7a7d2410.png";